import { z } from 'zod';
import { ISODateTimeSchema, UUIDSchema } from './common';
export const FileCategorySchema = z.enum(['document', 'image']);
export const FileSchema = z.object({
    uuid: UUIDSchema,
    name: z.string(),
    created_on: ISODateTimeSchema,
    category: FileCategorySchema,
    is_included_into_the_report: z.boolean(),
    url: z.string(),
    tags: z.string().array().optional(),
});
export const DocumentSchema = FileSchema.extend({
    category: z.literal('document'),
});
export const ImageSchema = FileSchema.extend({
    category: z.literal('image'),
    thumbnail_url: z.string().optional(),
});
export const FileItemSchema = z.union([DocumentSchema, ImageSchema]);
export const FileWithContentTypeSchema = FileSchema.extend({
    content_type: z.string().optional(),
});
export const ImageWithContentTypeSchema = FileWithContentTypeSchema.extend({
    category: z.literal('image'),
    thumbnail_url: z.string().optional(),
});
